import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';

/**
 * Retrieves the available MFA methods for the current user.
 *
 * This function fetches information about which multi-factor authentication
 * methods are available and configured for the user's account.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the user's MFA methods configuration.
 */
export const getMfaMethods = async (client = getDefaultClient()) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const userMfaMethods = await apiClient.getUserMfaMethods({
    environmentId: core.environmentId,
    verifiedOnly: true,
  });

  return userMfaMethods;
};
